import React from "react";
import { useTranslation } from "react-i18next";
import { ProgramPath as SharedProgramPath } from "@sophy/shared-ui";

/**
 * The four marks of a program — first session, first full week, halfway,
 * finished — worded for the patient. `milestones` comes from
 * programMilestones(); the drawing is shared-ui's.
 */
export function ProgramPath({ milestones, direction = "vertical" }) {
  const { t, i18n } = useTranslation();
  const { steps, current, half, done, planned } = milestones;

  const formatDate = (date) =>
    date.toLocaleDateString(i18n.language, {
      day: "numeric",
      month: direction === "vertical" ? "long" : "short",
    });

  const sub = (step) => {
    if (step.reached && step.at) return formatDate(step.at);
    if (step.id === "completed") return t("gamification.path.sessions", { done, planned });
    if (step.id === "first_week") return t("gamification.path.first_week_open");
    if (step.remaining) return t("gamification.path.remaining", { count: step.remaining });
    return null;
  };

  const items = steps.map((step, index) => ({
    id: step.id,
    label: t(`gamification.path.${step.id}`),
    sub: sub(step),
    reached: step.reached,
    current: index === current,
    pin: step.id === "completed" ? "flag" : step.id === "halfway" ? half : index + 1,
  }));

  return <SharedProgramPath items={items} direction={direction} />;
}

export default ProgramPath;
